import React, { Component } from "react";

import anicommerce_website_back_office from "../../../img/ppe/4/anicommerce_website_back_office.png";
import anicommerce_website_card from "../../../img/ppe/4/anicommerce_website_card.png";
import anicommerce_website_backoffice_shop_hours from "../../../img/ppe/4/anicommerce_website_backoffice_shop_hours.png";
import anicommerce_website_backoffice_shops from "../../../img/ppe/4/anicommerce_website_backoffice_shops.png";
import anicommerce_website_item from "../../../img/ppe/4/anicommerce_website_item.png";
import anicommerce_website_create_shop from "../../../img/ppe/4/anicommerce_website_create_shop.png";
import anicommerce_website_daily_item from "../../../img/ppe/4/anicommerce_website_daily_item.png";
import anicommerce_website_item_edit from "../../../img/ppe/4/anicommerce_website_item_edit.png";
import anicommerce_website_item_edit_1 from "../../../img/ppe/4/anicommerce_website_item_edit_1.png";
import anicommerce_website_item_pic from "../../../img/ppe/4/anicommerce_website_item_pic.png";
import anicommerce_website_item_shop from "../../../img/ppe/4/anicommerce_website_item_shop.png";
import anicommerce_website_item_shop_filter from "../../../img/ppe/4/anicommerce_website_item_shop_filter.png";
import anicommerce_website_user_info from "../../../img/ppe/4/anicommerce_website_user_info.png";
import anicommerce_website_user_edit from "../../../img/ppe/4/anicommerce_website_user_edit.png";
import anicommerce_website_shops from "../../../img/ppe/4/anicommerce_website_shops.png";
import anicommerce_website_shop_info from "../../../img/ppe/4/anicommerce_website_shop_info.png";
import anicommerce_website_shop_edit from "../../../img/ppe/4/anicommerce_website_shop_edit.png";
import anicommerce_website_search_and_card from "../../../img/ppe/4/anicommerce_website_search_and_card.png";
import anicommerce_website_qte_define from "../../../img/ppe/4/anicommerce_website_qte_define.png";
import anicommerce_website_login from "../../../img/ppe/4/anicommerce_website_login.png";

import anicommerce_android_1 from "../../../img/ppe/4/anicommerce_android_1.png";
import anicommerce_android_2 from "../../../img/ppe/4/anicommerce_android_2.png";
import anicommerce_android_3 from "../../../img/ppe/4/anicommerce_android_3.png";
import anicommerce_android_4 from "../../../img/ppe/4/anicommerce_android_4.png";
import anicommerce_android_5 from "../../../img/ppe/4/anicommerce_android_5.png";
import anicommerce_android_6 from "../../../img/ppe/4/anicommerce_android_6.png";

const imagesWebPPE4 = [
	anicommerce_website_back_office,
	anicommerce_website_card,
	anicommerce_website_backoffice_shop_hours,
	anicommerce_website_backoffice_shops,
	anicommerce_website_item,
	anicommerce_website_create_shop,
	anicommerce_website_daily_item,
	anicommerce_website_item_edit,
	anicommerce_website_item_edit_1,
	anicommerce_website_item_pic,
	anicommerce_website_item_shop,
	anicommerce_website_item_shop_filter,
	anicommerce_website_user_info,
	anicommerce_website_user_edit,
	anicommerce_website_shops,
	anicommerce_website_shop_info,
	anicommerce_website_shop_edit,
	anicommerce_website_search_and_card,
	anicommerce_website_qte_define,
	anicommerce_website_login
];
const imagesAndroidPPE4 = [
	anicommerce_android_1,
	anicommerce_android_2,
	anicommerce_android_3,
	anicommerce_android_4,
	anicommerce_android_5,
	anicommerce_android_6
];

export default class PPE4 extends Component {
	render() {
		return (
			<>
				<div className="container">
					<div className="row mt-5">
						<div className="col-lg-12">
							<div className="section-title">
								<h2>Information</h2>
								<p>
									<b>❯ Project(s) : </b> Projet Personnel Encadré 4<br/>
									<b>❯ Technologie(s) : </b> Php, SQL (DQL), Javascript, Composer, Java (Android)<br/>
									<b>❯ Framework(s) : </b> Symfony, Doctrine (ORM)<br/>
									<b>❯ Base de données : </b> MySQL, Webservice API<br/>
									<b>❯ Spécialités : </b> SLAM<br/>
									<b>❯ Date : </b> 2020<br/>
									<b>❯ Lien Github : </b> <a href="https://github.com/pedrokarim/AniCommerceWeb">Site Web</a> et <a href="https://github.com/pedrokarim/AniCommerceAndroid">Android</a><br/>
								</p>
							</div>
						</div>
					</div>

					<div className="row mt-3">
						<div className="col-lg-12">
							<h3 className="text-heading">SLAM (Solutions Logicielles et Applications Métier)</h3>

							<h4 className="mb-20">Project AniCommerce (en cours de développement)</h4>

							<p>
								Ce projet s'insère dans la continuité de l'apprentissage du développement informatique pendant ma formation BTS SIO.
								Je l'ai nommé AniCommerce parce que j'ai décidé de créer un site web de gestion des divers magasins qui vont vendre des
								produits en lien avec les mangas et la JapAnimation.
								<br/>
								<br/>
								<em>
									Il faut surtout faire attention ici, c'était un projet de classe où l'on avait carte blanche sur le site web que nous allions créer.
									Nous avions des technologies obligatoires à utiliser pendant ce projet, puisque le but principal, c'était d'apprendre à utiliser ces technologies,
									nous avions carte blanche pour l'image que l'on souhaitait donner à notre création donc notre site web.
								</em>
								<br/>
								<br/>
								Comparer aux autres projets personnels encadrés celui-ci était obligatoirement gérer tout seul.
							</p>

							<h5 className="mb-20">Site web</h5>

							<div className="row">
								<div className="col-md-4">
									<a href={anicommerce_website_login} className="img-gal">
										<img src={anicommerce_website_login} alt="" className="img-fluid" />
									</a>
									{imagesWebPPE4.map(i => <a href={i} className="img-gal"> </a>)}
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<h6>Description</h6>
									<br/>

									<p>
										Le but principal du professeur était de nous donner un cas d'étude concret pour utiliser le framework que l'on a appris à utiliser
										avant ce projet personnel encadré, ce framework c'est <a href="https://symfony.com/" target="_blank" rel="noopener noreferrer">Symfony</a>.
										Donc quelques fonctionnalités étaient obligatoire pendant le développement de se site web.
										Par exemple, il était obligé de d'implémenter l'API <a href="https://www.google.com/recaptcha/about/"  target="_blank" rel="noopener noreferrer">ReCaptcha</a> pendant la connexion de l'utilisateur sur notre site web,
										ou encore la possibilité d'exporter et d'importer nos données utilisateurs sur l'interface de l'utilisateur.

										<em>Quelques captures d'écran du site web sont disponibles n'hésitez pas à cliquer sur l'image et à faire défiler les images suivantes.</em>
									</p>

									<h6>Magasins et Produits des magasins</h6>
									<br/>

									<p>
										Sur notre site web on devait mettre en place un système de gestion des magasins, donc côté back-office on devait mettre en place le CRUD (Create, Read, Update, Delete)
										des magasins. Donc la création, suppression, modification et affichage des informations des magasins.

										<br/>
										Et bien sûr, il doit y avoir la possibilité de créer, modifier, supprimer un produit et bien sûr qu'il soit rattaché au magasin.
									</p>

									<h6>Un système de paymant</h6>
									<br/>

									<p>
										On devait mettre en place un système de paiement en bac à sable donc comme tous mes camarades de classe j'ai opté pour paypal.
									</p>
								</div>
							</div>

							<h5 className="mb-20">Webservice</h5>
							<p>
								Pour nous initier au monde de l'API pendant ce projet personnel encadré on devait créer une partie webservice.
								Cette partie webservice va devoir alimenter les informations disponibles sur l'application Android qui vient ci-dessous. <br/>

								<em>
									Prit au dépourvu du temps qu'il nous restait et la pandémie de COVID qui s'est déclaré à ce moment-là on n'a pas pu finir globalement ce projet.
								</em>
							</p>

							<h5 className="mb-20">Application android</h5>

							<div className="row">
								<div className="col-md-4">
									<a href={anicommerce_android_1} className="img-gal">
										<img src={anicommerce_android_1} alt="" className="img-fluid" />
									</a>
									{imagesAndroidPPE4.map(i => <a href={i} className="img-gal"> </a>)}
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<h6>Description</h6>
									<br/>

									<p>
										Pendant ce projet personnel encadré on avait l'obligation de faire une application
										Android qui communiquerai avec le web service que l'on aura créé en amont pour exposer nos produits.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

			</>
		);
	}
}